import { render, staticRenderFns } from "./tuopo.vue?vue&type=template&id=fd608f2a&scoped=true&"
import script from "./tuopo.vue?vue&type=script&lang=js&"
export * from "./tuopo.vue?vue&type=script&lang=js&"
import style0 from "./tuopo.vue?vue&type=style&index=0&id=fd608f2a&prod&scoped=true&lang=scss&"
import style1 from "./tuopo.vue?vue&type=style&index=1&id=fd608f2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd608f2a",
  null
  
)

export default component.exports